// extracted by mini-css-extract-plugin
module.exports = {"topHeader":"Highlights-module--topHeader--2pwV1","topDescription":"Highlights-module--topDescription--2Iu8k","title":"Highlights-module--title--1SK1T"};